import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { cn } from "@/lib/utils";
import Logo from "./Logo";
import { ADMIN_MENU, CLIENT_MENU } from "./menu";
import { useAuth } from "@/context/AuthContext";

export default function Sidebar({ onNavigate }) {
  const { user, logout } = useAuth();
  const menu = user?.role === "super_admin" ? ADMIN_MENU : CLIENT_MENU;

  return (
    <div className="flex h-full flex-col bg-white">
      <div className="flex h-16 items-center border-b border-slate-100 px-5">
        <Logo />
      </div>
      <nav className="flex-1 space-y-1 overflow-y-auto scrollbar-thin px-3 py-4">
        {menu.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              cn(
                "group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all",
                isActive
                  ? "bg-brand-700 text-white shadow-brand"
                  : "text-slate-600 hover:bg-brand-50 hover:text-brand-700"
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon className={cn("h-5 w-5 shrink-0", isActive ? "text-white" : "text-slate-400 group-hover:text-brand-600")} strokeWidth={1.8} />
                <span className="truncate">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-slate-100 p-3">
        <button
          onClick={logout}
          data-testid="sidebar-logout-btn"
          className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-slate-600 transition-all hover:bg-red-50 hover:text-red-600"
        >
          <LogOut className="h-5 w-5 text-slate-400" strokeWidth={1.8} />
          Logout
        </button>
      </div>
    </div>
  );
}
